import { z } from 'zod';

const ticketsSchema = z.object({
    individuais: z.number(),
    infantis: z.number(),
    cortesias: z.number(),
    motivoCortesia: z.string(),
    guia: z.object({
        value: z.string(),
        label: z.string()
    }).or(z.null()),
    sessao: z.object({
        diaHora: z.string(),
        extrasAdicionados: z.boolean(),
        label: z.string(),
        ticketsDisponiveis: z.number(),
        value: z.string()
    }),
    horarioEspecial: z.object({
        diaHora: z.string(),
        extrasAdicionados: z.boolean(),
        label: z.string(),
        ticketsDisponiveis: z.number(),
        value: z.string()
    }),
    visitante: z.object({
        nome: z.string(),
        email: z.string(),
        celular: z.string()
    }),
    aceitaMarketing: z.boolean()
})

export default ticketsSchema;